import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import {DEGREE_SIGN, MELTING_TEMP_ABBREVIATION} from 'util/UnicodeSymbols';

interface PrimerMinMeltingTempProps {
  primerMinMeltingTemp: number | null;
  updatePrimerMinMeltingTemp: (temp: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set minimum melting temperature for primers used in a Gibson assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.primerMinMeltingTemp The minimum melting temperature, in degrees Celsius, of any primers used in the assembly.
 * @param {function} updatePrimerMinMeltingTemp A function that takes a new temperature and uses it to update state.
 * @constructor
 */
export function PrimerMinMeltingTemp(props: PrimerMinMeltingTempProps): JSX.Element {
  return (
    <InputWrapper
      id="primerMinMeltingTemp"
      label={`Min. ${MELTING_TEMP_ABBREVIATION} of whole primer (${DEGREE_SIGN}C)`}
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.primerMinMeltingTemp}
        required={true}
        onChange={(e) => {
          props.updatePrimerMinMeltingTemp(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
